import { Box, Button, FormControl, FormHelperText, TextField, Typography, useTheme } from '@mui/material'
import { Form, Formik, ErrorMessage, Field } from 'formik'
import { useState } from 'react'
import * as Yup from 'yup'
import bgImg from '../../assets/young-student-min.jpg'
import aliveLogo from '../../assets/alivelogo.png'
import { useAuthStore } from '../../store/auth.store'
import { useNavigate } from 'react-router-dom'

export default function Signin() {

    const authStore = useAuthStore()
    const { palette } = useTheme()

    const navigate = useNavigate()

    const [isLoggingIn, setIsLoggingIn] = useState( false )

    const initialValues = {
        email: '',
        password: ''
    }


    const validationSchema = Yup.object().shape( {
        email: Yup.string().required( "This field is required!" ),
        password: Yup.string().required( "Password field is required!" )
    } )

    const signIn = async ( values ) => {
        setIsLoggingIn( true )
        let status = await authStore.doAuth( { "user_email": values.email, "user_password": values.password } )
        if ( status ) {
            navigate( '/admin/home' )
            setIsLoggingIn( false )
        } else {
            setIsLoggingIn( false )
        }
    }


    return (
        <Box bgcolor="#eee" color="primary.main" display="flex" height="100%" alignItems="center" width="100%" justifyContent="center" flexWrap="wrap" sx={{ overflowX: "hidden", background: "url('/imgs/bg-pattern1.png')" }}>
            <Box height={{ md: "80% !important", xs: "100% !important" }} width={{ md: "900px !important", xs: "100% !important" }} minHeight="615px" borderRadius={{ sm: "5px !important", xs: "0 !important" }} bgcolor="white" alignItems="center" display="grid" gridTemplateColumns={{ md: "50% 50% !important", xs: "0 100% !important" }}>
                <Box height="100%" width="100%" display="flex" flexWrap="wrap" overflow="hidden">
                    <img height="100%" width="100%" style={{ borderRadius: "5px 0 0 5px", objectFit: "cover" }} src={bgImg} alt="Login Background" />
                </Box>
                <Box>
                    <Box height="100%" sx={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
                        <img src={aliveLogo} style={{ marginLeft: "-10px", marginBottom: "10px" }} width="100px" alt="Alive Logo" />
                        <Typography variant='h6' component="h1" textAlign="center" gutterBottom>Management & Monitoring Portal</Typography>
                        <Formik initialValues={initialValues} onSubmit={signIn} validationSchema={validationSchema}>
                            {( props ) => (
                                <Form method='post' autoComplete='off' style={{ margin: "20px 0", display: "flex", flexDirection: "column", gap: "10px", width: "100%", alignItems: "center" }}>
                                    <FormControl sx={{ width: { md: "320px", xs: "100%" }, maxWidth: "450px", marginBottom: "10px" }} >
                                        <Field as={TextField} InputLabelProps={{ sx: { color: "primary.main !important", fontSize: "14px" } }} sx={{ borderRadius: "2px", background: "#fff", outline: 'none', width: { sm: "100%", xs: "95% !important" }, margin: { sm: "initial", xs: "auto !important" }, "&:focus": { borderLeft: "5px solid #f9b17a", } }} type="text" name='email' variant='outlined' label="Email" />
                                        <Typography sx={{ color: palette.error.dark }} variant="subtitle2" color="error"><FormHelperText sx={{ color: "inherit", fontWeight: "inherit" }} ><ErrorMessage name='email' /></FormHelperText></Typography>
                                    </FormControl>
                                    <FormControl sx={{ width: { md: "320px", xs: "100%" }, maxWidth: "450px", marginBottom: "10px" }} >
                                        <Field as={TextField} InputLabelProps={{ sx: { color: "primary.main !important", fontSize: "14px" } }} sx={{ borderRadius: "2px", background: "#fff", outline: 'none', width: { sm: "100%", xs: "95% !important" }, margin: { sm: "initial", xs: "auto !important" }, "&:focus": { borderLeft: "5px solid #f9b17a", } }} type="password" name='password' variant='outlined' label="Password" />
                                        <Typography sx={{ color: palette.error.dark }} variant="subtitle2" color="error"><FormHelperText sx={{ color: "inherit", fontWeight: "inherit" }} ><ErrorMessage name='password' /></FormHelperText></Typography>
                                    </FormControl>
                                    <FormControl sx={{ width: { md: "320px", xs: "100%" }, maxWidth: "450px", marginBottom: "10px" }}>
                                        <Box display="flex" justifyContent="center">
                                            <Button sx={{ textTransform: "capitalize", width: { sm: "100%", xs: "95% !important" }, height: "53px" }} disableElevation type='submit' color='primary' variant='contained' disabled={isLoggingIn}>{isLoggingIn ? "Logging in..." : "Login"}</Button>
                                        </Box>
                                    </FormControl>
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </Box>
            </Box>
        </Box >
    )
}
